<div class="product-item-carousel">
    <h-carousel
        [isMobile]="isMobile"
        [isLoopEnabled]="!isMobile"
        [carouselTitle]="productSlug"
        [assets]="carouselAsset"
        [wrapAssetInsideButton]="true"
        [isControlsDisplayed]="!isMobile"
        (slideChanged)="handleSlideChange($event)"
        (clickOnAsset)="openZoomModal($event)">
        <ng-content></ng-content>
    </h-carousel>
</div>
